import { rm, withCurrentPage } from 'utils';
import { useSelector } from 'react-redux';
import { getIsBundleSavings, getIsCampaign, getIsLoweredPrice } from 'views/ProductPage/selector';

interface Props {
  className?: string;
}

export const SpecialPriceMeta = ({ className }: Props) => {
  const isCampaign = useSelector(withCurrentPage(getIsCampaign));
  const isLoweredPrice = useSelector(withCurrentPage(getIsLoweredPrice));
  const isBundleSavings = useSelector(withCurrentPage(getIsBundleSavings));

  const isSpecialPrice = isCampaign || isLoweredPrice || isBundleSavings;
  if (!isSpecialPrice) return null;

  const priceInformation = isBundleSavings
    ? 'product_bundle_savings_information'
    : 'productpage_baseprice_info';

  return <p className={className}>{rm(priceInformation)}</p>;
};
